import FixtureCardSecondSlot from './fixtureCardSecondSlot.component';

export * from './fixtureCardSecondSlot.types';
export default FixtureCardSecondSlot;
